/* eslint-disable no-unused-vars */
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import style from "../../styles/factura.module.css";
import { useFactura } from "../../actions/facturaId";

function ABMFacturas() {
   const location = useLocation();
   const navigate = useNavigate();
   const { state } = location;

   const id = state?.id || 0;
   const { data, isLoading, error } = useFactura(id);

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   const formatCurrency = (value) => {
      return new Intl.NumberFormat("es-AR", {
         style: "currency",
         currency: "ARS",
         minimumFractionDigits: 0,
         maximumFractionDigits: 0,
      }).format(value);
   };

   if (isLoading) {
      return (
         <div className={style.container}>
            <div className={style.loadingContainer}>
               <p className={style.loadingText}>Cargando factura...</p>
            </div>
         </div>
      );
   }

   if (error) {
      return (
         <div className={style.container}>
            <div className={style.errorContainer}>
               <p className={style.errorText}>Error: {error.message}</p>
               <button
                  className={style.inputBtnNew}
                  onClick={() => navigate("/factura")}
               >
                  VOLVER
               </button>
            </div>
         </div>
      );
   }

   if (!data) {
      return (
         <div className={style.container}>
            <div className={style.errorContainer}>
               <p className={style.errorText}>No se encontró la factura</p>
               <button
                  className={style.inputBtnNew}
                  onClick={() => navigate("/factura")}
                  >
                  VOLVER
               </button>
            </div>
         </div>
      );
   }
   
   console.log('data: ', data);
   return (
      <div className={style.container}>
         <div className={style.facturaCard}>
            {/* Header */}
            <div className={style.header}>
               <h2 className={style.title}>Detalle de la Factura</h2>
               <p className={style.subtitle}>
                  Factura N° {data.id} - {formatDate(data.fecha)}
               </p>
            </div>

            {/* Main Grid: Left (Client/Service Info) and Right (Details) */}
            <div className={style.mainGrid}>
               {/* Left Column: Client and Professional Info */}
               <div className={style.leftColumn}>
                  <div className={style.infoSection}>
                     <h3 className={style.sectionTitle}>
                        Información del Cliente
                     </h3>
                     <div className={style.infoItem}>
                        <span className={style.label}>Nombre:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.cliente.nombre}</b>
                        </span>
                     </div>
                     <div className={style.infoItem}>
                        <span className={style.label}>Documento:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.cliente.documento}</b>
                        </span>
                     </div>
                     <div className={style.infoItem}>
                        <span className={style.label}>Teléfono:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.cliente.telefono}</b>
                        </span>
                     </div>
                     <div className={style.infoItem}>
                        <span className={style.label}>Email:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.cliente.email}</b>
                        </span>
                     </div>
                  </div>

                  <div className={style.infoSection}>
                     <h3 className={style.sectionTitle}>
                        Información del Servicio
                     </h3>
                     <div className={style.infoItem}>
                        <span className={style.label}>Profesional:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.user.username}</b>
                        </span>
                     </div>
                     {/* <div className={style.infoItem}>
                        <span className={style.label}>Fecha:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.fecha}</b>
                        </span>
                     </div> */}
                     <div className={style.infoItem}>
                        <span className={style.label}>Forma de pago:</span>
                        <span className={style.value}>
                           &nbsp;<b>{data.formaspago.descripcion}</b>
                        </span>
                     </div>
                     <div className={style.infoItem}>
                        <span className={style.label}>Total:</span>
                        <span className={style.totalValue}>
                           &nbsp;<b>{formatCurrency(data.total)}</b>
                        </span>
                     </div>
                  </div>
               </div>

               {/* Right Column: Services, Products, and Insumos */}
               <div className={style.rightColumn}>
                  {/* Services */}
                  {data.servicios?.length > 0 && (
                     <div className={style.detailSection}>
                        <h3 className={style.sectionTitle}>Servicios</h3>
                        <table className={style.detailTable}>
                           <thead>
                              <tr>
                                 <th>Descripción</th>
                                 <th className={style.centerAlign}>Cantidad</th>
                                 <th className={style.rightAlign}>Precio</th>
                              </tr>
                           </thead>
                           <tbody>
                              {data.servicios.map((serv) => (
                                 <tr key={serv.id}>
                                    <td>{serv.descripcion}</td>
                                    <td className={style.centerAlign}>
                                       {serv.presupuestoservicio.cantidad}
                                    </td>
                                    <td className={style.rightAlign}>
                                       {formatCurrency(
                                          serv.presupuestoservicio.precioFijo
                                       )}
                                    </td>
                                 </tr>
                              ))}
                           </tbody>
                        </table>
                     </div>
                  )}

                  {/* Products */}
                  {data.productos?.length > 0 && (
                     <div className={style.detailSection}>
                        <h3 className={style.sectionTitle}>Productos</h3>
                        <table className={style.detailTable}>
                           <thead>
                              <tr>
                                 <th>Descripción</th>
                                 <th className={style.centerAlign}>Cantidad</th>
                                 <th className={style.rightAlign}>Precio</th>
                              </tr>
                           </thead>
                           <tbody>
                              {data.productos.map((prod) => (
                                 <tr key={prod.id}>
                                    <td>
                                       {prod.descripcion} ^ {prod.size} Ø{" "}
                                       {prod.gauge}
                                    </td>
                                    <td className={style.centerAlign}>
                                       {prod.presupuestoproducto.cantidad}
                                    </td>
                                    <td className={style.rightAlign}>
                                       {formatCurrency(
                                          prod.presupuestoproducto.precioFijo
                                       )}
                                    </td>
                                 </tr>
                              ))}
                           </tbody>
                        </table>
                     </div>
                  )}

                  {/* Insumos */}
                  {data.insumos?.length > 0 && (
                     <div className={style.detailSection}>
                        <h3 className={style.sectionTitle}>Insumos</h3>
                        <table className={style.detailTable}>
                           <thead>
                              <tr>
                                 <th>Descripción</th>
                                 <th className={style.centerAlign}>Cantidad</th>
                                 <th className={style.rightAlign}>Precio</th>
                              </tr>
                           </thead>
                           <tbody>
                              {data.insumos.map((ins) => (
                                 <tr key={ins.id}>
                                    <td>
                                       {ins.descripcion}
                                       {ins.presupuestoinsumo.tipoinsumo ===
                                          1 && (
                                          <span className={style.badge}>
                                             {" "}
                                             - Agregado
                                          </span>
                                       )}
                                    </td>
                                    <td className={style.centerAlign}>
                                       {ins.presupuestoinsumo.cantidad}
                                    </td>
                                    <td className={style.rightAlign}>
                                       {formatCurrency(
                                          Math.round(
                                             ins.recargoCalculado *
                                                ins.presupuestoinsumo.cantidad
                                          )
                                       )}
                                    </td>
                                 </tr>
                              ))}
                              <tr className={style.totalRow}>
                                 <td colSpan="2" className={style.totalLabel}>
                                    Total Insumos
                                 </td>
                                 <td className={style.rightAlign}>
                                    {formatCurrency(data.netoinsumo  - data.netoprod || 0)}
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  )}
               </div>
            </div>

            {/* Actions */}
            <div className={style.actions}>
               <button
                  className={style.backButton}
                  onClick={() => navigate("/factura")}
               >
                  VOLVER
               </button>
               &nbsp;&nbsp;&nbsp;&nbsp;
               <button
                  className={style.printButton}
                  onClick={() => window.print()}
               >
                  IMPRIMIR
               </button>
            </div>
         </div>
         <br />
      </div>
   );
}

export default ABMFacturas;
